import React, { useEffect, useState, useRef, useMemo } from 'react';
import clsx from 'clsx';

import './index.scss';
import {
  DROPDOWN_INITIAL_ITEM,
  ROOT_ELEMENT_ID,
} from 'utils/constant';

const DropdownInput = ({ items, selectedValue, onChange, isOpen = false }) => {
  const ulRef = useRef(null);
  const [ open, setOpen ] = useState(isOpen);
  const [ border, setBorder ] = useState(false);
  
  const selectedIdx = useMemo(() => {
    const ret = items.reduce((acc, item, idx) => {
      if(item.value === selectedValue){
        return idx;
      }
      return acc;
    }, -1);
    return ret;
  }, [ items, selectedValue ]);
  const selectedItem = items[selectedIdx];
  const noSelect = selectedItem.value === '';

  const handleOpenLink = () => {
    // 開く／閉じる
    const isUlOpen = ulRef.current.offsetHeight > 0;
    setOpen(!isUlOpen);
    setBorder(true);

    // スクロール位置
    const listHeight = 41.5;
    const scrollTop = (selectedIdx - 3) * listHeight;
    ulRef.current.scrollTop = scrollTop > 0 ? scrollTop : 0;
  };
  useEffect(() => {
    const root = document.getElementById(ROOT_ELEMENT_ID);
    root.addEventListener('click', () => {
      setOpen(false);
      setBorder(false);
    });
  }, []);
   
  return (
    <div
      className={clsx(
        'DropdownInput',
        { many: items.length > 5 },
        { open },
        { noSelect },
      )}
    >
      {/* 開閉リンク */}
      <div className={clsx('A-DI-wrapper', { border })}>
        <div className="A-DI-selected-item">
          <button
            href="#open"
            className="button"
            type="button"
            onClick={handleOpenLink}
          >
            {selectedItem.label}
            <div className="allow" />
          </button>
        </div>
        
        {/* ドロップダウン */}
        <ul className="A-DI-list-wrapper" ref={ulRef}>
          {items.map(item => {
            // 空は選択不可
            if(item.value === DROPDOWN_INITIAL_ITEM.value) return null;

            const isSelected = item.value === selectedItem.value;
            return (
              <li
                className={clsx('A-DI-list', { isSelected })}
                key={`key-${item.value}`}
              >
                <button
                  className="button"
                  type="button"
                  onClick={() => {
                    // クリック要素の key を返却
                    onChange(item.value);
                    setOpen(false);
                  }}
                >
                  {item.label}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default DropdownInput;